module.exports = __webpack_public_path__ + "static/media/intro.a71f10cc.png";